const grid = {
  small: "576px",
  medium: "768px",
  large: "992px",
  extraLarge: "1200px",
}

export default grid
